// extracted by mini-css-extract-plugin
export default {"grid":"home-module--grid--g_z4Z"};